import { Transition } from '@headlessui/react'

import { Button } from '../..'
import MasaIcon from './logo.png'
import VezgoIcon from './vezgo.svg'
export interface WelcomeProps {
    onClick?: () => void
    show: boolean
}

export function Welcome({ show, onClick }: WelcomeProps): JSX.Element {
    return (
        <Transition
            appear={true}
            show={show}
            className='flex flex-col items-center justify-center h-full gap-4 px-8 py-8'
            as='div'
            enter='transition'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='transition'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'>
            <p className='text-xl text-center text-white'>
                <b>Masa</b> uses <b>Vezgo</b> to securely link your wallets
            </p>
            <div className='flex flex-row items-center justify-center text-white'>
                <img
                    src={MasaIcon}
                    style={{ width: '60px' }}
                    className='mr-4'
                    alt='masa-logo'
                />
                <p className='text-3xl font-semibold text-center'>+</p>
                <img
                    alt='vezgo-logo'
                    style={{ width: '120px' }}
                    className='w-1/2 ml-4'
                    src={VezgoIcon}
                />
            </div>

            <Button
                onClick={onClick}
                style={{ background: 'white', maxWidth: '400px' }}
                className='px-32 mt-12 text-black lg:w-full w-max lg:mt-0 bottom-12 lg:bottom-0 lg:relative'>
                Continue
            </Button>
        </Transition>
    )
}
